'use strict';

import * as dom from './lib/dom.js';
import axios from 'axios';

const loadSvg = () => {
    dom.all('.js-replace-with-svg').forEach(el => {
        const url = el.getAttribute('data-url').trim();

        if (!/\.svg$/.test(url)) { return; }

        axios.get(encodeURI(url), {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'crossDomain': true
            },
        }).then(response => {
            console.log(response.data);
            el.innerHTML = response.data;
        });

        // axios({
        //     method:'get',
        //     url: encodeURI(url),
        //     headers: {
        //         'Access-Control-Allow-Origin': '*',
        //     },
        // })
        // .then(function(response) {
        //     console.log(response.data);
        //     el.innerHTML = response.data;
        // });
    });
}

export default function(){
    window.addEventListener('load', function() {
        loadSvg();
    });

}
